<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <v-dialog
      v-model='dialog'
      persistent
      max-width="50%"
    >
      <v-card>
        <v-card color="blue">
          <v-card-title flat class='white--text title'>{{ $t('TITLE_DELETE_ITEM', { type: item.type, id:item.id }) }}</v-card-title>
        </v-card>

        <v-card-text>
          <v-layout justify-start row wrap>
            <v-flex md12>
              {{ 'QUESTION_DELETE_ITEM' | translate}}
            </v-flex>
            <v-flex md12>
              {{item.name}}
            </v-flex>
          </v-layout>


        </v-card-text>
        <v-card-actions>
          <v-btn color="#004884" small dark outline class="radiusBtn text-none" @click="dialog = false">{{ 'BUTT_DELETE_ITEM_STOP' | translate}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#004884" small dark class="radiusBtn text-none" @click="deleteItem()">{{ 'BUTT_DELETE_ITEM' | translate}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'DialogDeleteItem',
    components: {},
    methods: {
      open: function (item) {
        this.dialog = true
        this.item = item
      },
      deleteItem: function () {
        this.dialog = false
        this.$emit('doDelete', this.item)
      }
    },
    data () {
      return {
        dialog: false,
        item: {}
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogDeleteItem.vue